module.exports = __webpack_public_path__ + "b618b2378463d746f2ac5c3268114ead.svg";